<template>
  <div class="login-wrap">
    <div class="login-card">
      <div class="login-brand">
        <div class="brand-mark">井</div>
        <div>
          <div class="brand-title">泉井守望者</div>
          <div class="brand-sub">管理后台</div>
        </div>
      </div>
      <el-form ref="form" :model="form" :rules="rules" class="login-form" @keyup.enter.native="handleLogin">
        <el-form-item prop="username">
          <el-input v-model="form.username" prefix-icon="el-icon-user" placeholder="账号" size="large" />
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="form.password" prefix-icon="el-icon-lock" placeholder="密码" show-password size="large" />
        </el-form-item>
        <el-button type="primary" class="login-btn" :loading="loading" @click="handleLogin">登录</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import { adminLogin } from '@/api'

export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      form: { username: '', password: '' },
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    handleLogin() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.loading = true
        try {
          const res = await adminLogin(this.form)
          localStorage.setItem('xjb_admin_logged', '1')
          localStorage.setItem('xjb_admin_token', res.token)
          localStorage.setItem('xjb_admin_user', JSON.stringify(res))
          this.$message.success('登录成功')
          this.$router.replace('/')
        } catch (e) {
          this.$message.error('账号或密码错误')
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-wrap {
  min-height: 100vh;
  background: linear-gradient(135deg, #0d3322 0%, #1a5c3c 50%, #2eb67d 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-card {
  background: #fff;
  border-radius: 20px;
  padding: 48px 44px 40px;
  width: 380px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.18);
}
.login-brand {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 36px;
}
.brand-mark {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: #2eb67d;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 26px;
  color: #fff;
  flex-shrink: 0;
}
.brand-title {
  font-size: 20px;
  font-weight: 800;
  color: #123c2f;
}
.brand-sub {
  font-size: 13px;
  color: #7a9e8e;
  margin-top: 2px;
}
.login-form ::v-deep .el-input__inner {
  height: 44px;
  line-height: 44px;
  border-radius: 10px;
  font-size: 15px;
}
.login-form ::v-deep .el-form-item {
  margin-bottom: 20px;
}
.login-btn {
  width: 100%;
  height: 44px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 700;
  margin-top: 8px;
  background: #2eb67d;
  border-color: #2eb67d;
}
.login-btn:hover {
  background: #27a06e;
  border-color: #27a06e;
}
</style>
